<!-- @/views/ShowDetails.vue -->
<template>
  <d2-container>
    <top-line :message="pageTitle" :iconclass="'fa fa-users'"></top-line>
      <div class="back-button">
        <el-button @click="goBackWithPagination" icon="el-icon-arrow-left">返回</el-button>
      </div>
     <el-card shadow="hover" style=" margin: 20px 20px;">
      <el-descriptions title="设备基本信息" :column="2" border :colon="true" >
        <!-- 基本信息 -->
        <el-descriptions-item label="设备名称">{{ detail.hostname }}</el-descriptions-item>
        <el-descriptions-item label="数据中心ID">{{ detail.dc_id }}</el-descriptions-item>
        <el-descriptions-item label="主机IP">{{ detail.host_ip }}</el-descriptions-item>
        <el-descriptions-item label="IPMI地址">{{ detail.ipmi_addr }}</el-descriptions-item>
        <el-descriptions-item label="IPMI用户">{{ detail.ipmi_user }}</el-descriptions-item>
        <el-descriptions-item label="设备类型">{{ detail.dev_type }}</el-descriptions-item>
        <el-descriptions-item label="设备角色">{{ detail.dev_character }}</el-descriptions-item>
        <el-descriptions-item label="状态">{{ formatStatus(detail.status) }}</el-descriptions-item>
        <el-descriptions-item label="使用状态">{{ formatActiveState(detail.active_state) }}</el-descriptions-item>
        <el-descriptions-item label="运行状态">{{ formatRunningState(detail.running_state) }}</el-descriptions-item>
        <el-descriptions-item label="提供商">{{ detail.provider }}</el-descriptions-item>
        <el-descriptions-item label="提供商ID">{{ detail.provider_id }}</el-descriptions-item>
        <el-descriptions-item label="可用区名称">{{ detail.az_name }}</el-descriptions-item>
        <el-descriptions-item label="可用区ID">{{ detail.az_id }}</el-descriptions-item>
        <el-descriptions-item label="设备规格">{{ detail.dev_spec }}</el-descriptions-item>
        <el-descriptions-item label="备注">{{ detail.remark }}</el-descriptions-item>
        <el-descriptions-item label="资源可用期限">
          {{ detail.start_time || '–' }} 至 {{ detail.end_time || '–' }}
        </el-descriptions-item>
        <el-descriptions-item label="机房ID">{{ detail.house_id }}</el-descriptions-item>
        <el-descriptions-item label="设备描述">{{ detail.desc }}</el-descriptions-item>
        <el-descriptions-item label="所属模块ID">{{ detail.module_id }}</el-descriptions-item>
        <el-descriptions-item label="机柜ID">{{ detail.rack_id }}</el-descriptions-item>
        <el-descriptions-item label="设备位置">{{ detail.dev_pos }}</el-descriptions-item>
        <el-descriptions-item label="配电柜编号">{{ detail.ecab_id }}</el-descriptions-item>
        <el-descriptions-item label="配电柜支路">{{ detail.ecab_branch }}</el-descriptions-item>
        <el-descriptions-item label="PDU编号">{{ detail.pdu_id }}</el-descriptions-item>
        <el-descriptions-item label="动环系统ID">{{ detail.envsys_id }}</el-descriptions-item>
        <el-descriptions-item label="动环系统地址">{{ detail.envsys_addr }}</el-descriptions-item>
        <el-descriptions-item label="动环系统SNMP">{{ detail.envsys_snmp }}</el-descriptions-item>
        <el-descriptions-item label="动环MIB文件位置">{{ detail.envsys_mib }}</el-descriptions-item>
        <el-descriptions-item label="Node Exporter地址">{{ detail.exporter_node }}</el-descriptions-item>
        <el-descriptions-item label="IPMI Exporter地址">{{ detail.exporter_ipmi }}</el-descriptions-item>
        <el-descriptions-item label="DCGM Exporter地址">{{ detail.exporter_dcgm }}</el-descriptions-item>
        <el-descriptions-item label="服务器规格描述">{{ detail.spec_desc }}</el-descriptions-item>
      </el-descriptions>

      <el-row style="margin-top: 30px; text-align: center;">
        <el-button @click="goBackWithPagination">返回</el-button>
      </el-row>
    </el-card>

  </d2-container>
</template>


<script>
import topLine from "@/components/save-common/topLine.vue";

export default {
  name: 'ShowDetails',
  components: {
    topLine
  },
  data() {
    return {
      pageTitle: "设备详情",
      labelWidth: '120px',
      detail: {}
    }
  },
  created() {
    const devId = this.$route.query.dev_id;
    if (devId) {
      this.fetchDetail(devId);
    } else {
      console.error('No dev_id provided');
    }
  },
  methods: {
    async fetchDetail(id) {
      try {
        const response = await this.$axios.get(`/api-30216/api/devices/${id}`); 
        this.detail = response.data; // 假设响应直接包含设备详情
      } catch (error) {
        console.error('Failed to fetch device details', error);
      }
    },
    formatDevType(val) {
      const map = {
        '0': '服务器',
        '1': '虚拟机',
        '2': '容器',
        '3': '交换机',
        '4': '防火墙',
        '5': '路由器',
        '6': '动环系统',
        '7': '录像机或摄像头',
        '8': '传感器'
      };
      return map[val] || '未知';
    },
    formatStatus(val) {
      const map = { '0': '有效', '1': '无效'};
      return map[val] || '未知';
    },
    formatActiveState(val) {
      const map = { '0': '空闲', '1': '占用', '2': '维护中' };
      return map[val] || '未知';
    },
    formatRunningState(val) {
      const map = { '0': '在线', '1': '离线'};
      return map[val] || '未知';
    },
    goBackWithPagination() {
      const previousPagePath = '/api/devices'; 
      // 获取当前路由中的分页信息
      const { page, pageSize } = this.$route.query;
      this.$router.push({
        path: previousPagePath,
        query: {
          page: page || 1,       // 如果没有page参数，默认为第一页
          pageSize: pageSize || 10, // 如果没有pageSize参数，默认每页显示10条
        }
      });
    },
  }
}
</script>
<style scoped>
.back-button {
  margin-left: 20px;
}

</style>